import { Directive } from '@angular/core';
/**
  * @hidden
  */
var ItemGroup = (function () {
    function ItemGroup() {
    }
    ItemGroup.decorators = [
        { type: Directive, args: [{
                    selector: 'ion-item-group'
                },] },
    ];
    /** @nocollapse */
    ItemGroup.ctorParameters = function () { return []; };
    return ItemGroup;
}());
export { ItemGroup };
//# sourceMappingURL=item-group.js.map


// WEBPACK FOOTER //
// item-group.ts